// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"c3d37d41","312":"5abe553a","401":"aa7441a7","540":"7278ce6d","607":"dc3b88e7","644":"4c9c3214","777":"aae54e3f","787":"ebff6c10"}[chunkId] + ".chunk.js";
};